import axios, { isAxiosError } from 'axios'

const api = axios.create({
  baseURL: '/api/v1/',
  xsrfCookieName: 'csrftoken',
  xsrfHeaderName: 'X-CSRFToken',
})

const NAVIGATING_AWAY = new Promise<never>(() => {})

api.interceptors.response.use(undefined, error => {
  if (isAxiosError(error) && error.response?.status === 401) {
    const { pathname, search, hash } = window.location
    const next = encodeURIComponent(pathname + search + hash)
    window.location.assign(`/login/?next=${next}`)
    return NAVIGATING_AWAY
  }
  return Promise.reject(error)
})

export default api
